export default __webpack_public_path__ + "static/media/950.efa35876.png";